/** Install a same-origin fetch wrapper that forwards the CSRF cookie token. */
export function installCsrfFetch() {
    if (typeof window === 'undefined' || window.__corecryCsrfFetchInstalled) return
    const nativeFetch = window.fetch.bind(window)
    const mutationMethods = new Set(['POST', 'PUT', 'PATCH', 'DELETE'])

    window.fetch = (input, init = {}) => {
        const requestUrl = typeof input === 'string' ? input : input?.url || ''
        const target = new URL(requestUrl, window.location.origin)
        const method = String(init.method || (typeof input === 'object' ? input.method : 'GET') || 'GET').toUpperCase()
        if (target.origin === window.location.origin && mutationMethods.has(method)) {
            const token = document.cookie
                .split('; ')
                .find((entry) => entry.startsWith('csrf_token='))
                ?.slice('csrf_token='.length)
            if (token) {
                const headers = new Headers(init.headers || (typeof input === 'object' ? input.headers : undefined))
                headers.set('X-CSRF-Token', decodeURIComponent(token))
                init = { ...init, headers }
            }
        }
        return nativeFetch(input, init)
    }
    window.__corecryCsrfFetchInstalled = true
}
